export default __webpack_public_path__ + "static/media/core_insight.e55503da.png";